import classNames from 'classnames';
import React, { FC } from 'react';

import styles from './Breadcrumb.module.scss';

export interface DataType {
  text: string;
  link?: string;
}

interface Props {
  className?: string;
  data: DataType[];
  subTitle?: string;
}

const Breadcrumb: FC<Props> = (props) => {
  const { className, data, subTitle } = props;

  const lastNav = data[data.length - 1];
  const lastNavNode = lastNav && <div className={`${styles['current-link']} mt-font`}>{lastNav.text}</div>;

  const historyNav = data.slice(0, data.length - 1);
  const historyNavNode =
    historyNav.length &&
    historyNav.map((navItem, idx) => {
      const { text, link } = navItem;
      return (
        <React.Fragment key={idx}>
          {idx !== 0 && <i className="pl-1 pr-1.5">|</i>}
          <a
            className={classNames(styles['nav-item'], `${link ? 'hover:text-black-dark hover:underline' : ''}`)}
            href={link}
            rel="noreferrer"
            key={idx}
          >
            {text}
          </a>
        </React.Fragment>
      );
    });

  return (
    <div className={classNames(styles['bread-crumb-wrap'], className)}>
      <div className={styles['bread-crumb-container']}>
        <div className={styles['bread-crumb-data-container']}>
          {historyNavNode && <div className={styles['bread-crumb-data-history']}>{historyNavNode}</div>}
          {lastNavNode}
          {subTitle && <div className={`${styles['sub-title']}`}>{subTitle}</div>}
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
